import { demoHoldings } from "./demo-holdings";

export const holdingsQuery = {
  read(_: any) {
    return {
      offsetInfo: {
        limit: 20,
        offset: 0,
        total: 1,
      },
      holdings: demoHoldings,
    };
  },
};
